import { useState } from "react";
import styled from "styled-components";

interface Props {
  title?: string;
  version: string;
  open: boolean;
  children: React.ReactNode;
}

const AccordionProduct = ({ title, version, open, children }: Props) => {
  const [showInfo, setShowInfo] = useState(open);
  return (
    <Wrapper>
      <article className={`accordion-product ${version}`}>
        <header onClick={() => setShowInfo(!showInfo)}>
          <div className="header-wrapper">
            {/* {version == 'combin' && <Combin />} */}

            <h4>{title}</h4>
          </div>
          <button className={`btn ${showInfo ? null : "active"}`}>
            <svg
              width={14}
              height={8}
              viewBox="0 0 14 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13 7L7 1L1 7"
                stroke="#3A4155"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </header>
        {showInfo && (
          <div className="acc-cont">
            <div className="wrapper">{children}</div>
          </div>
        )}
      </article>
    </Wrapper>
  );
};

export default AccordionProduct;

const Wrapper = styled.div`
  .accordion-product {
    width: 100%;
    // border-top: 1px solid rgba($color: #0c0d1e, $alpha: 0.1);
    // border-bottom: 1px solid rgba($color: #0c0d1e, $alpha: 0.1);
    // cursor: pointer;
    // box-shadow: 0px 0px 12px -8px rgba(0, 0, 0, 6%);
    border-radius: 6px;
    margin-bottom: 36px !important;
  }

  .accordion-product h4 {
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 100%;
    color: #3a4155;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    svg {
      margin-right: 6px;
    }

    @media only screen and (max-width: 600px) {
      font-size: 18px;
    }
  }

  .accordion-product .acc-cont {
    font-style: normal;
    font-weight: normal;
    font-size: 1.4rem;
    line-height: 170%;
    color: rgba($color: #0c0d1e, $alpha: 0.5);
    padding: 0 2.4rem 2.4rem 2.4rem;

    .wrapper {
      padding-top: 2.4rem;
      border-top: 1px solid rgba(196, 196, 196, 0.25);

      * {
        font-size: 21px;
        color: #0c0d1e; 
      }
    }

    @media only screen and (max-width: 600px) {
      font-size: 1.5rem;
    }

    &::-webkit-scrollbar {
      width: 2.4rem;
    }

    &::-webkit-scrollbar-track {
      margin-bottom: 2.4rem;
      border-radius: 0.2rem;
      height: 100%;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba($color: #0c0d1e, $alpha: 0.1);
      border-radius: 1.6rem;
      border: 10px solid transparent;
      background-clip: padding-box;
    }

    &::-webkit-scrollbar-track-piece {
      background: rgba($color: #0c0d1e, $alpha: 0.1);
      background: transparent;
    }

    .popup-buy-as-guest {
      .container {
        .header {
          display: none;
        }

        .body {
          padding: 0;
          margin-top: 0;

          .fast-buy-inputs {
            margin: 0;
          }
        }

        .footer-popup {
          position: relative;
          padding: 0;
        }
      }
    }
  }

  .accordion-product header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 6rem;
    // background-color: #fff;
    padding-left: 2.4rem;
    padding-right: 2.4rem;
    border-radius: 3px;
    cursor: pointer;

    .header-wrapper {
      display: flex;
      align-items: center;
    }
  }

  .accordion-product header h4 {
    margin-bottom: 0;
  }

  .btn {
    border-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    align-self: center;
    transition: all 0.3s;
    outline: none;
    width: 2.8rem;
    height: 2.8rem;
    background-color: transparent;

    @media only screen and (max-width: 600px) {
      width: 2rem;
      height: 2rem;
    }

    svg {
      width: 1.6rem;
      height: 1.6rem;
      object-fit: cover;

      @media only screen and (max-width: 600px) {
        width: 2rem;
        height: 2rem;
      }
    }
  }

  .accordion-product.acc-side {
    width: 100%;
    border: none;
    padding: 0;
    margin-bottom: 0;
    border-radius: 6px;

    h4 {
      font-size: 22px !important;
      font-weight: 700 !important;
    }

    p {
      // max-height: 25rem;
      // overflow-y: auto;
    }

    .btn {
      height: 2.8rem;
      width: 2.8rem;

      &.active {
        transform: rotate(-180deg);
      }
    }

    .checkbox-group {
      padding-bottom: 1.2rem;

      &:last-child {
        padding-bottom: 0;
      }
    }
  }

  .fg {
    display: flex;
    margin-bottom: 10px;

    svg {
      width: 20px !important;
      height: 20px !important;
      margin-right: 10px;
      stroke: #989eaf;
      margin-top: 8px;
    }

    .icon-container {
      height: 30px;
    }

    .content {
      h1 {
        display: inline-flex;
        height: auto !important;
        font-size: 15px !important;
        line-height: normal !important;
        margin-right: 20px;
        word-break: break-all !important;
        margin-bottom: 0 !important;
        min-width: 200px !important;
      }

      .subtitle {
        font-size: 15px !important;
      }
    }
  }
`;
